<template>
  <div>
    <v-container grid-list-md class="white text-left">
      <v-row>
        <v-col cols="12" class="body-2 grey--text text-left pb-0">
          <div>
            <v-breadcrumbs :items="routeItems" divider=">"></v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-0">
          <p class="h6 mb-0">Lista de ordenes por series</p>
          <p class="headline">No. Serie: {{ seriesMachine }}</p>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!exist">
      <v-row no-gutters>
        <v-col cols="12" class="text-center"
          >La serie del equipo que buscaste no pudo ser encontrado.</v-col
        >
      </v-row>
    </v-container>
    <v-container
      v-else
      class="pt-0"
      v-for="(data, index) in orders"
      :key="index"
    >
      <v-col cols="12" class="pb-0" v-if="data">
        <v-card class="pa-2" link @click="goToOrder(data.id)">
          <p class="title ml-1 mt-2 mb-0 font-weight-regular">
            No. Pedido: {{ data.saleOrderID }}
          </p>
          <p class="title ml-1 mb-0 font-weight-regular">
            No. Orden: {{ data.id }}
          </p>
          <p class="subheading ml-1 mt-1 mb-0 font-weight-light">
            Contacto: {{ data.userContact }}
          </p>
          <p class="subheading ml-1 mt-1 mb-0 font-weight-light">
            Tel: {{ data.userPhone }}
          </p>
        </v-card>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      seriesMachine: this.$route.params.seriesID,
      orders: [],
      exist: true
    };
  },
  async mounted() {
    if (this.$route.params.seriesID) {
      const data = await this.getSearchedSerie(this.$route.params.seriesID);
      if (data) {
        this.orders = data;
        this.exist = true;
      } else this.exist = false;
    }
  },
  computed: {
    ...mapState("detail", ["dataOrder", "dataEquipment"]),
    routeItems() {
      let routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        element = unescape(element);
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      return routeItems;
    }
  },
  methods: {
    ...mapActions("detail", ["getSearchedSerie"]),
    goToOrder(orderNumber) {
      this.$router.push({
        name: "search",
        params: {
          orderNumber: orderNumber,
          orderType: "order"
        }
      });
    }
  }
};
</script>
